import Axios from "@/configs/axios"

/*
 *  *  *  *  *  *  * 接口 *  *  *  *  *  *  
 */
const catalog = '/vcm'
export function fetchDetailsData(data, loading) {
  return Axios.get(`${catalog}/rlist`, data, loading);
}